import { getSiteConfig } from '@shared/config';
import { AdditionalInformationSection } from './AdditionalInformationSection/AdditionalInformationSection';
import { ContactSection } from './ContactSection/ContactSection';
import { CopyrightAndSocialsSection } from './CopyrightAndSocialsSection/CopyrightAndSocialsSection';
import { Divider } from './Divider/Divider';
import { NavigationLinksSection } from './NavigationLinksSection/NavigationLinksSection';
import { UnderageSection } from './UnderageSection/UnderageSection';

function Footer() {
  const {
    footerConfig: { contactSection, navigationLinks, additionalInformation, underageSection, copyrightAndSocials },
  } = getSiteConfig();

  return (
    <footer id="footer" role="contentinfo" className="bg-container-base py-6 border-t-4 border-t-accent-green ll-grid-container" data-track-section="Footer">
      <div className="ll-container-inner">
        {contactSection ? <ContactSection config={contactSection} /> : null}
        <Divider />
        {navigationLinks ? (
          <>
            <NavigationLinksSection config={navigationLinks} />
            <Divider />
          </>
        ) : null}
        {additionalInformation ? (
          <>
            <AdditionalInformationSection config={additionalInformation} />
            <Divider />
          </>
        ) : null}
        {underageSection ? (
          <>
            <UnderageSection config={underageSection} />
            {copyrightAndSocials ? <Divider /> : null}
          </>
        ) : null}
        {copyrightAndSocials ? <CopyrightAndSocialsSection config={copyrightAndSocials} /> : null}
      </div>
    </footer>
  );
}

export { Footer };
